var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Safras", {
        attrs: {
          nomeAba: _vm.nomeAba,
          anoSafra: _vm.forms.ano,
          areaDestinada: _vm.forms.areaDestinada,
          dataInicio: _vm.forms.dataInicio,
          praticasArray: _vm.pratica
        },
        on: {
          "update:anoSafra": function($event) {
            return _vm.$set(_vm.forms, "ano", $event)
          },
          "update:ano-safra": function($event) {
            return _vm.$set(_vm.forms, "ano", $event)
          },
          "update:areaDestinada": function($event) {
            return _vm.$set(_vm.forms, "areaDestinada", $event)
          },
          "update:area-destinada": function($event) {
            return _vm.$set(_vm.forms, "areaDestinada", $event)
          },
          "update:dataInicio": function($event) {
            return _vm.$set(_vm.forms, "dataInicio", $event)
          },
          "update:data-inicio": function($event) {
            return _vm.$set(_vm.forms, "dataInicio", $event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputSelect", {
            attrs: {
              label: "Há rotação de culturas?",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: _vm.rules,
              opcoes: [
                { id: true, nome: "Sim" },
                { id: false, nome: "Não" }
              ],
              widthColumn: 8
            },
            model: {
              value: _vm.forms.hasRotacaoCulturas,
              callback: function($$v) {
                _vm.$set(_vm.forms, "hasRotacaoCulturas", $$v)
              },
              expression: "forms.hasRotacaoCulturas"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.forms.hasRotacaoCulturas
        ? _c("CulturaProdutividade", {
            attrs: {
              nomeAba: _vm.nomeAba,
              culturasProdutividade: _vm.forms.atividadesAgricolaProdutividade
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Tipo de cobertura vegetal:",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: _vm.rules,
              opcoes: _vm.tipoCoberturaVegetal,
              widthColumn: 8,
              "multi-select": true
            },
            model: {
              value: _vm.forms.coberturasVegetais,
              callback: function($$v) {
                _vm.$set(_vm.forms, "coberturasVegetais", $$v)
              },
              expression: "forms.coberturasVegetais"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.forms.coberturasVegetais,
            "OUTRA",
            "outrosCoberturaVegetal"
          )
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      mode: "lazy",
                      name: _vm.nomeAba + "/Outro/qual"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("Label", {
                                attrs: {
                                  label: "Outro/qual",
                                  obrigatorio: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outro/qual", clearable: "" },
                                model: {
                                  value: _vm.forms.outrosCoberturaVegetal,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.forms,
                                      "outrosCoberturaVegetal",
                                      $$v
                                    )
                                  },
                                  expression: "forms.outrosCoberturaVegetal"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2428303830
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c("Financiamentos", {
        attrs: {
          nomeAba: _vm.nomeAba,
          pratica: _vm.forms,
          praticasArray: _vm.pratica
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "validation-provider",
            [
              _c(
                "el-col",
                { attrs: { span: 23 } },
                [
                  _c("Label", {
                    attrs: { label: "Descrição", obrigatorio: false }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: {
                      name: "Descrição",
                      type: "textarea",
                      maxlength: "500",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.forms.descricao,
                      callback: function($$v) {
                        _vm.$set(_vm.forms, "descricao", $$v)
                      },
                      expression: "forms.descricao"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-end mt-3 mb-3" },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.validationDisableButton,
                round: "",
                type: "primary"
              },
              on: { click: _vm.btnAdicionar }
            },
            [
              _vm._v(
                "\n       " +
                  _vm._s(_vm.isEdit ? "Salvar" : "Adicionar") +
                  " Ano/Safra\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", { attrs: { gutter: 20 } }, [
        _c(
          "div",
          { staticClass: "flex-wrapper row" },
          _vm._l(_vm.pratica, function(item, index) {
            return _c("Card", {
              key: index,
              attrs: {
                objeto: {
                  ano: item.ano,
                  areaDestinada: item.areaDestinada + " ha",
                  dataInicio: _vm.formataStringYearMonthToBr(item.dataInicio)
                },
                titulo: "Ano safra: " + (item.ano || ""),
                deletar: function() {
                  return _vm.removerPratica(index)
                },
                editar: function() {
                  return _vm.editarPratica(item, index)
                }
              }
            })
          }),
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bea10f92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bea10f92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SPDH/SPDH.vue
// module id = null
// module chunks = 